import pino from 'pino'
import { createRequire } from 'module'

/**
 * Global logger with bootstrap fallback.
 *
 * Initially creates a basic pino logger.
 * When the logger module initializes, it replaces the instance.
 */

const isDev = process.env['NODE_ENV'] !== 'production'

/**
 * Detects whether pino-pretty is available.
 * In production or when it is not installed, returns false.
 */
export function hasPinoPretty(): boolean {
  if (!isDev) return false
  try {
    const require = createRequire(import.meta.url)
    require.resolve('pino-pretty')
    return true
  } catch {
    return false
  }
}

// Logger inicial (fallback durante bootstrap, antes de que el módulo se inicialice)
let loggerInstance: pino.Logger = pino({
  level: process.env['LOG_LEVEL'] || 'info',
  redact: {
    paths: [
      'password', 'token', 'secret', 'authorization',
      'req.headers.authorization', 'req.headers.cookie'
    ],
    censor: '[REDACTED]'
  },
  transport: hasPinoPretty()
    ? { target: 'pino-pretty', options: { colorize: true, sync: true } }
    : undefined
})

/**
 * Replaces the logger instance.
 * Called from the logger module init().
 */
export function setLoggerInstance(instance: pino.Logger): void {
  loggerInstance = instance
}

/**
 * Proxy that delegates to the current logger.
 * Allows hot-swapping when the module initializes.
 */
export const logger = new Proxy({} as pino.Logger, {
  get(_, prop) {
    const target = loggerInstance as unknown as Record<string | symbol, unknown>
    const value = target[prop]
    // Bind methods para preservar `this`
    return typeof value === 'function' ? value.bind(loggerInstance) : value
  }
})

export const createChildLogger = (context: string) => logger.child({ context })
